import RestApiModel from "@/api/Model/RestApiModel";
import api, { fisgApi } from "@/api";

class ProductBundle extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-bundles';
  }

  static getBundles() {
    return fisgApi.get('GetORABundles');
  }

  static getRatersFromBundle(bundlePK) {
    return fisgApi.get('GetORARatersFromBundle', { params: { BundlePK: bundlePK } });
  }

  static listByType(typeId) {
    return api.get(this.getResourceEndpoint() + '/list-by-type/' + typeId);
  }
}

export default ProductBundle;
